// context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import API from '../api/MainApi';
import consts from '../config/consts.js';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        checkAuth();
    }, []);

    const checkAuth = async () => {
        try {
            const data = await API.getAdminProfile();
            setAdmin(data.admin);
        } catch (error) {
            console.error('Auth check failed:', error);
            setAdmin(null);
        } finally {
            setLoading(false);
        }
    };

    const signIn = async (login, password) => {
        setError(null);
        try {
            const data = await API.adminSignIn(login, password);
            setAdmin(data.admin);
            return data;
        } catch (error) {
            setError(error.response?.data?.message || 'Ошибка входа');
            throw error;
        }
    };

    const signOut = async () => {
        try {
            await API.adminSignOut();
            setAdmin(null);
        } catch (error) {
            console.error('Sign out error:', error);
        }
    };

    const hasPermission = (permission) => {
        if (!admin) return false;
        const permissions = consts.ROLE_PERMISSIONS[admin.role];
        return permissions?.[permission] || false;
    };

    const value = {
        admin,
        loading,
        error,
        signIn,
        signOut,
        hasPermission,
        isAuthenticated: !!admin
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};